/* global mixpanel */

export function ingredientCategoryStart ({outletIds}) {
  mixpanel.track('Ingredient Category Start', {
    'Current Selected Outlet': outletIds
  })
}

export function ingredientCategoryChangeOutlet ({outletIds}) {
  mixpanel.track('Ingredient Category Change Outlet', {
    'Current Selected Outlet': outletIds
  })
}

export function ingredientCategorySelect ({category}) {
  mixpanel.track('Ingredient Category Select', {
    'Name': category.name
  })
}

export function ingredientCategoryCreate ({category, allOutlet}) {
  let eventName
  if (allOutlet) {
    eventName = 'Ingredient Category Create All Outlet'
  } else {
    eventName = 'Ingredient Category Create One Outlet'
  }
  mixpanel.track(eventName, {
    'Name': category.name
  })
}

export function ingredientCategoryDelete ({category}) {
  mixpanel.track('Ingredient Category Delete', {
    'Name': category.name
  })
}

export function ingredientCategoryAssign ({category, data}) {
  mixpanel.track('Ingredient Category Assign', {
    'Name': category.name,
    'Ingredient List': data
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/ingredient/categories.js